import React, { ReactElement } from 'react';
import { PRODUCT_LABEL_SIZE } from 'b2b-components/core/components/ProductLabel/ProductLabel/ProductLabel';
import { EnergyLabel } from 'b2b-components/theme/components/EnergyLabel';
import { ADD_TO_CART_DISPLAY_TYPE, AddToCart } from 'b2b-apps/shop/cart/components/AddToCart/AddToCart';
import { ProductActions } from 'b2b-apps/shop/product/components/ProductActions';
import { BulkPrices } from 'b2b-apps/shop/product/components/ProductData/BulkPrices/BulkPrices';
import { BulletPoints } from 'b2b-apps/shop/product/components/ProductData/BulletPoints';
import { Features } from 'b2b-apps/shop/product/components/ProductData/Features';
import { Labels } from 'b2b-apps/shop/product/components/ProductData/Labels';
import { PriceList } from 'b2b-apps/shop/product/components/ProductData/PriceList';
import { ProductVariants } from 'b2b-apps/shop/product/components/ProductData/ProductVariants';
import { Props } from './';
import './ProductData.scss';

export const ProductData = ({
  product,
  onAddToCart,
}: Props): ReactElement => {
  const {
    effectivePricing,
    description: { energyLabel },
    settings,
    sku,
    variants,
  } = product;

  const {
    isNew,
    isOccasion,
    isSellout,
    isSpecialOffer,
    isCoreAssortment,
    isOwnAssortment,
  } = settings;

  const translation = product.description;

  return (
    <div className='ProductData'>
      <Labels
        size={PRODUCT_LABEL_SIZE.semilarge}
        className='ProductData-Labels'
        isNew={isNew}
        isOccasion={isOccasion}
        isSellout={isSellout}
        isSpecialOffer={isSpecialOffer}
        isCoreAssortment={isCoreAssortment}
        isOwnAssortment={isOwnAssortment}
      />
      <h1 className='ProductData-Title'>{translation.title}</h1>

      <PriceList effectivePricing={effectivePricing} />

      <BulkPrices
        className='ProductData-BulkPrices--Mobile'
        discounts={product.scaledDiscounts}
      />

      {energyLabel && (
        <EnergyLabel
          className="ProductData-EnergyLabel"
          range={energyLabel.range}
          rating={energyLabel.value}
        />
      )}

      <BulletPoints bulletPoints={translation.bulletPoints} />

      <Features
        sku={product.sku}
        ean={product.ean}
        manufacturerProductId={product.manufacturer.productId}
        manufacturerUrl={product.manufacturer.url}
        manufacturerName={product.manufacturer.name}
        manufacturerWarranty={product.manufacturer.warranty}
        manufacturerInternalPage={product.manufacturer.internalPage}
        soldSince={product.webDateStart}
        isSpecialOrder={product.settings.isSpecialOrder}
        quantityOrdered={product.settings.quantityOrdered}
        stockCount={product.settings.quantity}
      />

      {!!variants?.length
        && <div className='ProductVariants-Wrapper'>
          <ProductVariants sku={sku} variantGroups={variants} />
        </div>
      }

      <div className='ProductData-ActionsWrapper'>
        <div
          className='ProductData-Buy order-1 order-sm-0'
          data-test='addToCartPDP'
        >
          <AddToCart
            type={ADD_TO_CART_DISPLAY_TYPE.full}
            sku={product.sku}
            productName={translation.title}
            settings={product.settings}
            isUserCertified={effectivePricing.isCertified}
            onClick={onAddToCart}
          />
        </div>
        <ProductActions
          className="order-0 order-sm-1"
          product={product}
        />
      </div>

      <BulkPrices
        className="ProductData-BulkPrices--Desktop"
        discounts={product.scaledDiscounts}
      />
    </div>
  );
};
